<template>
  <div>
    <!-- Breadcrumb start -->
    <section class="bradcrumb_sec">
      <div class="container-fluid custome_container">
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="bread_crumb_box mb_22">
              <h2 class="heading_2 font_bold mb_23">
                Working from the lab <span class="text_primary">guide</span>
              </h2>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link
                      class="navbar-brand m-0 p-0"
                      :to="{ name: 'user_home' }"
                    >
                      Home
                    </router-link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Working from the lab
                  </li>
                </ol>
              </nav>
            </div>
            <h3 class="heading_3 font_bold mb_23 text-center">
                Less Strain, More Gain.
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Breadcrumb end -->
    <section
      :class="
        !show_self_assessment_block
          ? 'work_from_lab how_else_ergo mb-0'
          : 'work_from_lab how_else_ergo'
      "
    >
      <!-- <img src="../assets/images/work-from-office/first-section.png" alt="img" class="first_section"> -->
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xxl-12">
            <div class="row">
              <div
                v-for="(option, index) in lab_training_options"
                :key="index"
                class="col-md-6 col-lg-4"
              >
                <div class="custome_card card2">
                  <router-link
                    :to="{ name: labTrainingContentMap[option].route }"
                  >
                    <img
                      :src="labTrainingContentMap[option].image"
                      alt="img"
                      class="mb_66"
                    />
                    <div class="card2_text_box">
                      <h5
                        class="font_bold text-center font_size_26 mb_20 text_black"
                      >
                        {{ labTrainingContentMap[option].title }}
                      </h5>
                      <p class="text-center font_size_18 mb_20 text_black">
                        {{ labTrainingContentMap[option].description }}
                      </p>
                      <p class="text_balticsea font_size_14 text_black">
                        {{ labTrainingContentMap[option].journey }}
                      </p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section
      class="take_an_ergonomic_parttwo mb_44"
      v-show="show_self_assessment_block"
    >
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-12 col-xl-10">
            <div class="ergonomic-image pt_26 pb_26">
              <div class="overlay">
                <div class="row">
                  <div class="col-md-12 col-lg-7 col-xxl-6">
                    <div class="left-section pl_60 pr_60">
                      <h6 class="sub_heading_1 font_bold mb_22 text-white">
                        Take an ergonomic self-assessment
                      </h6>
                      <p class="text-white p_20 mb_54">
                        Take a self-assessment todayand see how ergo can help
                        you feel great, enjoy more energy and supercharge your
                        productivity.
                      </p>
                      <div class="mt_14">
                        <router-link
                          :to="{ name: 'self_assessment_signup' }"
                          class="btn btn_secondary font_size_16"
                          >Take a Self-Assessment</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_self_assessment_block: true,
      lab_training_options: [],
      labTrainingContentMap: {
        "Bench Work": {
          route: "bench_work",
          image: require("../assets/images/work_from_lab/lab-1.png"),
          title: "Bench Work",
          description: "When done right, bench work is a breeze. Learn more.",
          journey: "5 minute journey",
        },
        Pipetting: {
          route: "pipetting",
          image: require("../assets/images/work_from_lab/lab-2.png"),
          title: "Pipetting",
          description:
            "Learn how to side-step pipetting woes and learn how to feel great.",
          journey: "5 minute journey",
        },
        Microscopes: {
          route: "microscope",
          image: require("../assets/images/work_from_lab/lab-3.png"),
          title: "Microscopes",
          description:
            "Your eyes, back and neck will rejoice after learning these tips.",
          journey: "10 minute journey",
        },
        "Material Handling": {
          route: "material_handling",
          image: require("../assets/images/work_from_lab/lab-4.png"),
          title: "Material Handling",
          description:
            "Whether you are bending or lifting, we’ve got your back.",
          journey: "5 minute journey",
        },
        "Hood Work": {
          route: "hood_work",
          image: require("../assets/images/work_from_lab/lab-5.png"),
          title: "Hood Work",
          description: "No more awkward positions when doing your hood work.",
          journey: "5 minute journey",
        },
        "Lab Stretches": {
          route: "lab_stretches",
          image: require("../assets/images/work_from_lab/lab-6.png"),
          title: "Lab Stretches",
          description:
            "Combat awkward postures and work positions with these stretches.",
          journey: "5 minute journey",
        },
      },
    };
  },
  name: "Work_from_lab",
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    let data = this.$store.getters["auth/authUser"];
    let company_data = data.client;

    this.lab_training_options = JSON.parse(
      company_data.essentials.lab_training_options || "[]"
    );

    if (company_data.site_menu_details.TakeASelfAssessment.status == 0) {
      this.show_self_assessment_block = false;
    }
    if (localStorage.getItem("employeeEmail") == null) {
      this.$router.push({ name: "login" }).catch(() => true);
    }
  },
};
</script>
